import {t} from "ttag";
import {Tooltip} from "react-tooltip";
import {memo, useId} from "react";

export function relativeTime(date: Date | number, short: boolean = false) {
    let diffMs = Date.now() - (typeof date === 'object' ? date.getTime() : date);
    if (diffMs < 1000 * 120) { // < 2 min
        return t`now`;
    }
    const MINUTE = 60 * 1000;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;
    const MONTH = 30 * DAY;
    const YEAR = 365 * DAY;
    if (diffMs < HOUR) {
        const mn = Math.floor(diffMs / MINUTE);
        return short ? t`${mn}m` : t`${mn} minutes ago`;
    }
    if (diffMs < 2 * HOUR) {
        const mn = Math.floor(diffMs / MINUTE);
        return short ? t`1h` : t`1 hour ago`;
    }
    if (diffMs < DAY) {
        const hr = Math.floor(diffMs / HOUR);
        return short ? t`${hr}h` : t`${hr} hours ago`;
    }
    if (diffMs < 2 * DAY) {
        return short ? t`1d` : t`1 day ago`;
    }
    if (diffMs < MONTH) {
        const d = Math.floor(diffMs / DAY);
        return short ? t`${d}d` : t`${d} days ago`;
    }
    if (short) {
        const dateObj = typeof date === 'number' ? new Date(date) : date;
        if (diffMs < YEAR) {
            return dateObj.toLocaleDateString(undefined, {month: 'short', day: 'numeric'});
        }
        return dateObj.toLocaleDateString(undefined, {month: 'short', year: 'numeric'});
    }
    if (diffMs < 2 * MONTH) {
        return t`1 month ago`;
    }
    if (diffMs < YEAR) {
        const m = Math.floor(diffMs / MONTH);
        return t`${m} months ago`;
    }
    if (diffMs < 2 * YEAR) {
        return t`1 year ago`;
    }
    const y = Math.floor(diffMs / YEAR);
    return t`${y} years ago`;
}

export const RelativeTime = memo(function RelativeTime({date, short = false, tooltip = true} : {
    date: Date | number | string,
    short?: boolean,
    tooltip?: boolean
}) {
    const tooltipID = useId();
    if (typeof date === 'number' || typeof date === 'string') {
        date = new Date(date);
    }
    if (!tooltip) {
        return <span>relativeTime(date as Date, short)</span>
    }
    return <span><a data-tooltip-id={tooltipID} data-tooltip-content={date.toLocaleString()}><abbr>{relativeTime(date as Date, short)}</abbr></a>
        <Tooltip id={tooltipID}></Tooltip>
    </span>
})

